import { RequestType } from '@/form/form.types';
import { IUsers, IUsersItems, UsersReponseType } from './Users.types';

export class Users implements IUsers {
    total: number;
    data: Array<IUsersItems> = [];

    constructor(data: UsersReponseType) {
        this.total = data.total;
        for (let i = 0; i < data.data.length; i++) {
            this.data.push(data.data[i]);
        }
    }
}

export type UsersUpdateRequestType = RequestType & {
    id: number | null;
    name: string;
    role_id: number | null;
    phone: string;
    password: string;
    email: string;
    user_info: string;
    studios: Array<number>;
};

/*"name": "Алексеев Алексей Алексеевич",
  "role_id": 1,
  "phone": 30,
  "password": 30,
  "email": "test@test.ru",
  "user_info": "Какая-то информация",
  "studios": [
    1,
    2,
    3
  ]*/
